import React from "react";
import {findDOMNode} from "react-dom";


import Popover from "../../../../../../gd-components/gd-popover/popover";
import FieldTimeReported_CustomTime from "./components/custom-time";
import StartEndTime from "./components/start-end-time";
import MinutesPreset from "./components/minutes-preset";
import HoursPreset from "./components/hours-preset";
import FieldProto from "../../../../../proto/field-proto";
import FieldPopover_InlineEditable from "../../../../popover/render/inline-editable";
import FieldPopover_FormComponent from "../../../../popover/components/form/form-component";
import FieldTimeReported from "../../time-spent";
import FieldTimeReported_PopoverIsBillable from "./components/is-billable";
import FieldTimeSpent from "../../time-spent";

type Props = {
    parent      : FieldPopover_FormComponent | FieldPopover_InlineEditable, // can be other like inline edit etc.
    field       : FieldProto
    value       : any
    model?      : any
    className?  : string
    disabled?   : boolean
    onChange    : callback,
    targetOffset?   : any,
    options?    : any
    hideIsBillable? : boolean
};


export default function FieldTimeSpent_Popover(props:Props) {

    const field = props.field as FieldTimeSpent

    const onPresetClick = (value:number) => {
        props.parent.onValueChange(value, true)
    }

    const displayStartEnd = _.get(props.options, 'displayStartEnd', true) && field.hasStartEnd

    return (
        <Popover popoverClass               = ""
                 attachment                 = "top center"
                 targetAttachment           = "bottom center"
                 targetOffset               = {props?.targetOffset || "0 0"}
                 outsideClickIgnoreClass    = "popover-container"
                 onClickOutside             = {props.parent.hidePopover}
                 getTargetFunc              = {()=>findDOMNode(props.parent)}>

            <div className="wrapper">
                <div className="content p-15">

                    <FieldTimeReported_CustomTime parent={props.parent} model={props.model} field={field}/>

                    {displayStartEnd &&
                        <StartEndTime parent={props.parent} model={props.model}/>}

                    <div className="m-t-20">
                        <MinutesPreset onSubmit={onPresetClick} field={field} />
                        <HoursPreset onSubmit={onPresetClick} field={field} />
                    </div>

                    {gd.modules.timeTracking.isBillableTimeEnabled && field.canBeBillable && !props.hideIsBillable &&
                        <FieldTimeReported_PopoverIsBillable parent={props.parent} model={props.model} />
                    }


                </div>
            </div>

        </Popover>
    )
}
